<template>
  <!-- Ay / Yıl seçimleri (Liste temel filtreleri) - year-months select'e taşındı -->
  <!--
	<div class="r-flx r-mb-12" style="gap:8px; align-items:center;">
		<label>Ay:</label>
		<select v-model="workMonth" @change="reloadListWithFilters">
			<option v-for="m in months" :key="m" :value="m">{{ m }}</option>
		</select>
		<label>Yıl:</label>
		<select v-model="workYear" @change="reloadListWithFilters">
			<option v-for="y in years" :key="y" :value="y">{{ y }}</option>
		</select>
	</div>
	-->

  <!-- Ortak FilterBar: Soru Çeşidi / Branş / Kitap Türü / Kitap + dinamik property filtreleri -->
  <filter-bar
    ref="filterBarRef"
    :show-first-row="true"
    :show-filter-button="false"
    :show-dynamic-properties="true"
    :is-loading="isLoading"
    @property-change="onDynamicPropertyChange"
  >
    <!-- 1. satır: Yıl/Ay + Soru Çeşidi + Branş + Kitap Türü + Kitap -->
    <template #first-row>
      <r-select
        v-model="selectedYearMonth"
        label="Yıl / Ay"
        :data="yearMonthOptions"
        txt="txt"
        val="val"
        width="18%"
        @change="onYearMonthChange"
      />
      <r-select
        v-model="questPart"
        label="Soru Çeşidi"
        :data="questPartOptions"
        txt="txt"
        val="val"
        width="18%"
        @change="onQuestPartChange"
      />
      <r-select
        v-model="branchId"
        label="Branş"
        :data="branchOptions"
        txt="title"
        val="id"
        width="22%"
        style="color: rgb(17, 17, 17)"
        @change="onBranchChange"
      />
      <r-select
        v-model="subCategoryId"
        label="Alt Kategori"
        :data="subCategoryOptions"
        txt="title"
        val="id"
        width="22%"
        style="color: rgb(17, 17, 17)"
        :disabled="!branchId"
      />
    </template>

    <!-- Aksiyonlar: Filtreyi uygula + dinamik filtreleri temizle -->
    <template #actions>
      <r-select
        v-model="noteCategoryId"
        label="Kitap Türü"
        :data="noteCategoryOptions"
        txt="title"
        val="id"
        width="20%"
        @change="onNoteCategoryChange"
        style="color: rgb(17, 17, 17)"
      />
      <r-select
        label="Kitap"
        :data="noteOptions"
        txt="name"
        val="id"
        :selectable="true"
        v-model:selected="noteIds"
        width="24%"
        style="color: rgb(17, 17, 17)"
      />

      <r-btn
        bgcolor="#1e88e5"
        class="r-ml-8"
        @click="reloadListWithFilters"
        :disabled="isLoading"
      >
        Filtre
      </r-btn>
      <r-btn
        bgcolor="#ff9800"
        class="r-ml-8"
        @click="clearDynamicFilters"
        :disabled="isLoading"
      >
        Dinamik Filtreyi Temizle
      </r-btn>
    </template>
  </filter-bar>

  <r-data-list
    :headdata="headdata"
    :listdata="filteredData"
    :opt="opts"
    v-if="loaded"
    :searchfilter="searchfilter"
    v-model:qu="q"
  >
    <!-- Artık kategori/alt kategori seçimleri burada yok; sadece "Soruya Git" alanı kaldı -->
    <template v-slot:titleextrabuttons>
      <r-input v-model="qs" label="Soruya Git" width="15%" />
    </template>
    <template v-slot:col5="{ datarow }">
      {{ datarow.isCase ? "Evet" : "Hayır" }}
    </template>
    <template v-slot:col12="{ datarow }">
      <span
        class="r-check-ok small"
        v-if="datarow.isReferenced === true"
      ></span>
      <span class="r-check-no small" v-else></span>
    </template>
  </r-data-list>

  <r-panel
    title="Yeni Soru"
    v-if="newPanel"
    v-model:isactive="newPanel"
    classes="r-flx-dw-80"
    width="50%"
    pos="center"
  >
    <template v-slot:titlebuttons>
      <r-btn bgcolor="#15880d" @click="saveNew" :disabled="canSave"
        >Kaydet</r-btn
      >
    </template>
    <r-flex>
      <r-select
        v-model="newData.categoryId"
        label="Kategoriler"
        :data="catList.data"
        txt="title"
        val="id"
        width="47%"
        @change="openNewSubList"
      />
      <r-select
        :disabled="
          newData.categoryId === undefined || newData.categoryId === null
        "
        v-model="newData.subCategoryId"
        @change="newSubCatChange"
        label="Alt Kategoriler"
        :data="subNewCatList.data"
        txt="title"
        val="id"
        width="47%"
      />
    </r-flex>
    <r-flex v-if="newData.subCategoryId">
      <r-flex>
        <r-select
          :disabled="
            newData.categoryId === undefined || newData.categoryId === null
          "
          v-model="newData.month"
          label="Ay"
          :data="monthList.data"
          txt="monthName"
          val="id"
          width="47%"
        /><r-input v-model="newData.year" label="Yıl" width="47%" />
      </r-flex>
      <r-flex class="r-mb-16"
        ><r-input
          v-model="newData.number"
          label="Soru No"
          width="31%"
        /><r-input
          v-model="newData.examNumber"
          label="S. Soru No"
          width="31%"
        />
      </r-flex>
      <r-flex>
        <r-checkbox v-model="newData.isCase" label="Vaka Sorusu" />
        <template v-if="newData.isCase">
          <r-flex class="r-mb-16"><h4>Vaka</h4></r-flex>
          <vue-editor
            v-model="newData.case"
            label="Vaka"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          ></vue-editor
        ></template>
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Soru</h4></r-flex>
        <vue-editor
          v-model="newData.detail"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        />
      </r-flex>
      <r-flex>
        <r-flex
          flx="12"
          class="r-pr-32"
          v-if="newData.choiceList && newData.choiceList.length !== 5"
          ><r-flex class="r-mb-16"><h4>Şıklar</h4></r-flex
          ><r-textarea v-model="choisesTxt" label="Şıklar" rows="7"
        /></r-flex>
        <r-flex flx="12"
          ><r-flex v-if="newData.choiceList && newData.choiceList.length > 0">
            <template v-for="(choice, i) in newData.choiceList" :key="i">
              <r-flex class="r-mb-8"
                ><strong>{{
                  store.state.choices[i] + " Şıkkı"
                }}</strong></r-flex
              >
              <vue-editor
                height="100px"
                :editorToolbar="minToolbar"
                v-model="newData.choiceList[i]"
                @ImageAdded="imageAddedEditor"
                @ImagePasted="imagePastedEditor"
                :useCustomImageHandler="true"
                htmlBtn
              />
            </template> </r-flex
        ></r-flex>
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Açıklama</h4></r-flex>
        <vue-editor
          v-model="newData.description"
          label="Açıklama"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        ></vue-editor>
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Detay Modifield</h4></r-flex>
        <vue-editor
          v-model="newData.detailModifield"
          label="Detay Modifield"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        ></vue-editor>
      </r-flex>
      <r-flex
        ><r-select
          v-model="newData.answer"
          label="Cevap Şıkkı"
          :data="store.state.choices"
          width="30%"
      /></r-flex>
      <r-flex>
        <r-btn bgcolor="#15880d" @click="saveNew" :disabled="canSave"
          >Kaydet</r-btn
        >
      </r-flex>
    </r-flex>
  </r-panel>
</template>
<script>
import { onBeforeMount, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { trToUpper, mxDate } from "@/mix/global";
import FilterBar from "@/components/FilterBar/FilterBar.vue";
export default {
  components: {
    FilterBar
  },
  setup() {
    const store = useStore();
    const listData = ref({});
    const catList = ref({});
    const subCatList = ref({});
    const subNewCatList = ref({});
    const monthList = ref({});
    const catid = ref(null);
    const subcatid = ref(0);
    const newPanel = ref(false);
    const newData = ref({});
    const loaded = ref(false);
    const isLoading = ref(false);
    const q = ref("");
    const qs = ref("");
    const choisesTxt = ref("");

    // Ay / Yıl filtreleri
    const months = ref([]);
    const years = ref([]);
    const workMonth = ref("");
    const workYear = ref("");

    // Yıl-Ay kombinasyonları (QuestionArchives/year-months)
    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);

    // Dinamik property filtreleri ve ortak soru filtreleri için state
    const dynamicPropertyFilters = ref({});
    const filterBarRef = ref(null);

    const questPart = ref(null);
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const branchId = ref(null);
    const branchList = ref({ data: [] });
    const subCategoryId = ref(null);
    const subCategoryList = ref({ data: [] });

    const notesCatsList = ref({ data: [] });
    const noteCategoryId = ref(null);
    const noteList = ref({ data: [] });
    // Çoklu kitap seçimi için dizi
    const noteIds = ref([]);

    // Seçim listelerine "Lütfen Seçiniz" opsiyonu ekleyen computed'lar
    const questPartOptions = computed(() => {
      const base = questParts.value || [];
      return [{ txt: "Lütfen Seçiniz", val: null }, ...base];
    });

    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });

    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const subCategoryOptions = computed(() => {
      const arr =
        subCategoryList.value && Array.isArray(subCategoryList.value.data)
          ? subCategoryList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const noteCategoryOptions = computed(() => {
      const arr =
        notesCatsList.value && Array.isArray(notesCatsList.value.data)
          ? notesCatsList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const noteOptions = computed(() => {
      const src = noteList.value || {};
      const arr = Array.isArray(src.data)
        ? src.data
        : Array.isArray(src.Data)
        ? src.Data
        : [];
      return [{ name: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const searchfilter = v => {
      return (
        trToUpper(v.description).includes(trToUpper(q.value)) ||
        trToUpper(v.detail).includes(trToUpper(q.value)) ||
        trToUpper(v.case).includes(trToUpper(q.value)) ||
        trToUpper(v.choiceList).includes(trToUpper(q.value)) ||
        trToUpper(v.number).includes(trToUpper(q.value)) ||
        trToUpper(v.examNumber).includes(trToUpper(q.value))
      );
    };
    const goquestionfilter = v => {
      return trToUpper(v.examNumber).includes(trToUpper(qs.value));
    };
    const filteredData = computed(() => {
      if (listData.value.data) {
        listData.value.data.sort((a, b) => {
          return parseInt(a.examNumber) - parseInt(b.examNumber);
        });
        return listData.value.data.filter(goquestionfilter);
      } else return [];
    });
    const minToolbar = ref({
      container: [
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["image"],
        ["clean"]
      ]
    });
    const headdata = computed(() => {
      return [
        {
          title: "S. No",
          style: { width: "5%", justifyContent: "center" },
          key: "number"
        },
        {
          title: "S. S. No",
          style: { width: "5%", justifyContent: "center" },
          key: "examNumber"
        },
        {
          title: "Ay",
          style: { width: "6%", justifyContent: "center" },
          key: "month",
          cval: v => {
            let a = monthList.value.data.filter(d => {
              return d.id === v.month;
            })[0];
            return a ? a.monthName : "";
          }
        },
        {
          title: "Yıl",
          style: { width: "5%", justifyContent: "center" },
          key: "year"
        },
        {
          title: "Vaka mı?",
          style: { width: "4%", justifyContent: "center" },
          key: "isCase"
        },
        {
          title: "Vaka",
          style: { width: "14%" },
          key: "case",
          html: true
        },
        {
          title: "Soru",
          style: { width: "15%" },
          key: "detail",
          html: true
        },
        {
          title: "Şıklar",
          style: { width: "13%" },
          key: "choiceList",
          html: true,
          cval: v => {
            var str = "";
            v.choiceList.forEach((d, i) => {
              if (d.startsWith("<p>")) {
                str += `${d.slice(0, 3)}<strong>${
                  store.state.choices[i]
                }) </strong>${d.slice(3)}`;
              } else {
                str += "<strong>" + store.state.choices[i] + ": </strong>" + d;
                if (i !== v.choiceList.length - 1) str += "<br>";
              }
            });
            return str;
          }
        },
        {
          title: "Soru kökü",
          style: { width: "15%" },
          key: "detailModifield",
          html: true
        },
        {
          title: "Açıklama",
          style: { width: "14%" },
          key: "description",
          html: true,
          cval: v => {
            var str = "<strong>Cevap:</strong> " + v.answer + "<br>";
            str += v.description;
            return str;
          }
        },
        {
          title: "Tarih",
          style: { width: "7%" },
          key: "createDate",
          html: true,
          cval: v => {
            return mxDate("dd-mm-yy-t", v.createDate, ".");
          }
        },
        {
          title: "Referanslı mı?",
          style: { width: "6%", justifyContent: "center" },
          key: "isReferenced"
        }
      ];
    });
    const opts = ref({
      title: "Sorular",
      nodatatxt: () => {
        return catid.value === null
          ? "Lütfen kategori seçiniz"
          : filteredData.value && filteredData.value.length === 0
          ? "Sonuç bulunamadı"
          : "";
      },
      buttons: {
        style: { width: "6%" },
        edit: {
          show: true,
          func: d => {
            editFunc(d);
          }
        },
        delete: {
          show: true,
          func: d => {
            deleteFunc(d);
          }
        },
        add: {
          show: true,
          txt: "Yeni Soru",
          type: "out",
          func: d => {
            addFunc(d);
          }
        }
      }
    });
    const canSave = computed(() => {
      if (newData.value.isCase) {
        if (newData.value.case === undefined || newData.value.case === "")
          return true;
      }
      if (
        newData.value.categoryId &&
        newData.value.subCategoryId &&
        newData.value.month &&
        newData.value.year &&
        newData.value.year !== "" &&
        newData.value.number &&
        newData.value.number !== "" &&
        newData.value.examNumber &&
        newData.value.examNumber !== "" &&
        newData.value.choiceList &&
        newData.value.choiceList.length === 5
      )
        return false;
      else return true;
    });

    const imageAddedEditor = async (f, e, cl, ru) => {
      var rndm = parseInt(Math.random() * 10000000);
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = async () => {
        let s64file = reader.result.replace("data:image/jpeg;base64,", "");
        var ext = f.name.split(".").pop();
        var saveData = [
          {
            ImageString: s64file,
            Location:
              "soruresimleri/" +
              store.state.usertype +
              "/" +
              store.state.workFolder +
              "/" +
              newData.value.categoryId +
              "/" +
              f.name.split(".").shift() +
              "_" +
              rndm +
              "." +
              ext
          }
        ];
        let res = await store.dispatch("postDatas", {
          api: "references/saveimages",
          data: saveData
        });
        if (res.result) {
          let ind = (e.getSelection() || {}).index || e.getLength();
          if (ind < 0) ind = e.getLength();
          e.insertEmbed(
            ind,
            "image",
            "https://referans.tusem.com.tr/soruresimleri/" +
              store.state.usertype +
              "/" +
              store.state.workFolder +
              "/" +
              newData.value.categoryId +
              "/" +
              f.name.split(".").shift() +
              "_" +
              rndm +
              "." +
              ext
          );
          ru();
          let htm = e.root.innerHTML;
          e.root.innerHTML = htm;
          setTimeout(() => {
            e.setSelection(ind + 1);
          }, 1);
        }
      };
    };
    const imagePastedEditor = async (dataUrl, e, cl, type) => {
      var rndm = parseInt(Math.random() * 10000000);
      let s64file = dataUrl.replace("data:" + type + ";base64,", "");
      var ftype = type.includes("png") ? "png" : "jpg";
      var res = {};
      var intpaste = setInterval(async () => {
        if (s64file !== "") {
          clearInterval(intpaste);
          var saveData = [
            {
              ImageString: s64file,
              Location:
                "soruresimleri/" +
                store.state.usertype +
                "/" +
                store.state.workFolder +
                "/" +
                newData.value.categoryId +
                "/" +
                "soru_resim_" +
                newData.value.number +
                "_" +
                rndm +
                "." +
                ftype
            }
          ];
          res = await store.dispatch("postDatas", {
            api: "references/saveimages",
            data: saveData
          });
        }
      }, 50);

      var intimg = setInterval(() => {
        if (res.result) {
          clearInterval(intimg);
          let ind = (e.getSelection() || {}).index || e.getLength();
          if (ind < 0) ind = e.getLength();
          e.insertEmbed(
            ind,
            "image",
            "https://referans.tusem.com.tr/soruresimleri/" +
              store.state.usertype +
              "/" +
              store.state.workFolder +
              "/" +
              newData.value.categoryId +
              "/" +
              "soru_resim_" +
              newData.value.number +
              "_" +
              rndm +
              "." +
              ftype,
            "user"
          );
          let htm = e.root.innerHTML;
          e.root.innerHTML = htm;
          setTimeout(() => {
            e.setSelection(ind + 1);
          }, 1);
        }
      }, 100);
    };
    const getList = async (id, sid) => {
      // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
      const dynamicValues = dynamicPropertyFilters.value || {};
      const allValueIds = Object.values(dynamicValues)
        .reduce((acc, arr) => {
          if (Array.isArray(arr)) {
            return acc.concat(arr);
          }
          return acc;
        }, [])
        .filter((v, idx, arr) => arr.indexOf(v) === idx);

      // Eğer id/sid verilmişse onları kullan, yoksa FilterBar'daki questPart/branchId/subCategoryId değerlerini kullan
      const categoryId = id != null ? id : questPart.value || 0;
      // Alt kategori seçilmişse onu kullan, yoksa branş seçilmişse onu kullan, yoksa 0
      const subCategoryIdParam = sid != null ? sid : (subCategoryId.value || branchId.value || 0);

      const params = {
        categoryid: categoryId,
        subcatid: subCategoryIdParam,
        page: 1,
        size: 100,
        order: 1,
        workmonth: workMonth.value,
        workyear: workYear.value
      };

      // Ek filtreler: soru çeşidi / branş / alt kategori / kitap türü / kitap(lar)
      // Öncelik sırası: alt kategori > branş > soru çeşidi
      if (questPart.value != null) {
        params.questPart = questPart.value;
      }
      // Alt kategori seçilmişse, sadece alt kategoriyi gönder (daha spesifik)
      // Alt kategori seçilmemişse ama branş seçilmişse, branşı gönder
      if (subCategoryId.value) {
        // subCategoryId zaten subcatid parametresine eklendi, burada branchId göndermeyelim
      } else if (branchId.value) {
        params.branchId = branchId.value;
      }
      if (noteCategoryId.value) {
        params.noteCategoryId = noteCategoryId.value;
      }
      const uniqueNoteIds = Array.from(new Set(noteIds.value || []));
      if (uniqueNoteIds.length > 0) {
        params.noteIds = uniqueNoteIds.join(",");
      }

      if (allValueIds.length > 0) {
        // Backend şu an bu parametreyi kullanmıyor olabilir; şimdilik query'ye ekliyoruz.
        params.dynamicPropertyValueIds = allValueIds.join(",");
      }

      let list = await store.dispatch("getDatas", {
        api: "questions/GetQuestionsByCategory",
        params
      });
      return list;
    };
    const getCatList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: {
          pid: 0
        }
      });

      return list;
    };
    const getSubCatList = async b => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: {
          pid: b ? newData.value.categoryId : catid.value
        }
      });
      return list;
    };
    const getMonths = async () => {
      let list = await store.dispatch("getDatas", {
        api: "questions/getmonths"
      });
      return list;
    };

    // Arşiv sayfasındaki gibi distinct Ay/Yıl listeleri
    const loadMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "QuestionArchives/months"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      months.value = Array.isArray(arr) ? arr : [];
    };

    const loadYears = async () => {
      const res = await store.dispatch("getDatas", {
        api: "QuestionArchives/years"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      years.value = Array.isArray(arr) ? arr : [];
    };

    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "QuestionArchives/year-months"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };

    const ensureWorkFolder = async () => {
      // Eğer store'da workMonth/workYear varsa onları baz al, yoksa ilk elemanları kullan
      if (store.state.workYear) {
        workYear.value = store.state.workYear;
      } else if (!workYear.value && years.value.length > 0) {
        workYear.value = years.value[0];
      }

      if (store.state.workMonth) {
        workMonth.value = store.state.workMonth;
      } else if (!workMonth.value && months.value.length > 0) {
        workMonth.value = months.value[0];
      }
    };

    const onYearMonthChange = e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        workYear.value = year;
        workMonth.value = month;
        reloadListWithFilters();
      }
    };

    // Ortak filtreler için yardımcı API çağrıları (branş / kitap türü / kitap)
    const getNoteCatsList = async () => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return res;
    };

    const getNotesByCategory = async (categoryId, notCategoryId) => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return res;
    };
    const openSubList = async d => {
      catid.value = d.id;
      subCatList.value = await getSubCatList();
      subCatList.value.data.unshift({ id: 0, title: "Tümü" });
      subcatid.value = 0;
    };
    const openNewSubList = async d => {
      newData.value.categoryId = d.id;
      subNewCatList.value = await getSubCatList(true);
    };

    const addFunc = async () => {
      newData.value = {
        categoryId: catid.value,
        subCategoryId: subcatid.value,
        month: null,
        year: mxDate("yy"),
        number: null,
        examNumber: null,
        isCase: false,
        case: "",
        detail: "",
        detailModifield: "",
        description: "",
        answer: "",
        choiceList: [],
        workyear: store.state.workYear,
        workmonth: store.state.workMonth,
        isActive: true
      };
      choisesTxt.value = "";
      if (newData.value.subCategoryId) {
        const currentLen = Array.isArray(listData.value.data)
          ? listData.value.data.length
          : 0;
        newData.value.number = currentLen + 1;
      }
      subNewCatList.value = await getSubCatList(true);
      newPanel.value = true;
    };
    const editFunc = async d => {
      Object.assign(newData.value, d.row);
      subNewCatList.value = await getSubCatList(true);
      newPanel.value = true;
    };
    const deleteFunc = async d => {
      await store.dispatch("postDatas", {
        api: "questions/deletequestion",
        data: { id: parseInt(d.row.id) }
      });
      listData.value = await getList(catid.value, subcatid.value);
    };
    const saveNew = async () => {
      newData.value.case = newData.value.case || "";
      newData.value.isCase = newData.value.isCase || false;
      newData.value.number = parseInt(newData.value.number);
      newData.value.examNumber = parseInt(newData.value.examNumber);
      newData.value.year = parseInt(newData.value.year);
      newData.value.month = parseInt(newData.value.month);
      newData.value.description = newData.value.description || "";
      newData.value.detailModifield = newData.value.detailModifield || "";
      newData.value.isActive = true;
      await store.dispatch("postDatas", {
        api: "questions/addquestion",
        data: newData.value
      });
      listData.value = await getList(catid.value, subcatid.value);
      newPanel.value = false;
    };
    const newSubCatChange = async () => {
      newData.value = Object.assign({}, newData.value);
      var data = {};
      setTimeout(async () => {
        data = await getList(
          newData.value.categoryId,
          newData.value.subCategoryId
        );
        newData.value.number = data.data.length + 1;
      }, 50);
    };
    // Dinamik property değişimini FilterBar'dan al
    const onDynamicPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      if (!payload || payload.propertyDefinitionId == null) return;
      dynamicPropertyFilters.value = {
        ...dynamicPropertyFilters.value,
        [payload.propertyDefinitionId]: payload.selectedValues || []
      };
    };

    const clearDynamicFilters = () => {
      dynamicPropertyFilters.value = {};
      // FilterBar içindeki dinamik checkbox'ları da sıfırla
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
      // Mevcut kategori / alt kategori ile listeyi dinamik filtreler olmadan yeniden yükle
      reloadListWithFilters();
    };

    const reloadListWithFilters = async () => {
      isLoading.value = true;
      try {
        // Kategori/alt kategori yerine FilterBar'daki questPart/branchId değerlerini kullan
        listData.value = await getList(null, null);
      } finally {
        isLoading.value = false;
      }
    };

    // Soru Çeşidi değiştiğinde branş listesini güncelle
    const onQuestPartChange = async e => {
      if (!e || e.val === undefined) return;
      questPart.value = e.val;

      // Tüm alt kategorileri al (pid=0)
      const result = await getCatList();
      if (result && result.data && Array.isArray(result.data)) {
        const filteredData = result.data.filter(item => {
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          if (e.val === 1) {
            return parentId === 1;
          } else if (e.val === 2) {
            return parentId === 2;
          }
          return false;
        });
        branchList.value = { data: filteredData };
        branchId.value = null; // Seçimi kullanıcıya bırak
        subCategoryId.value = null; // Alt kategoriyi sıfırla
        subCategoryList.value = { data: [] }; // Alt kategori listesini temizle
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      }
    };

    // Branş değiştiğinde alt kategori listesini güncelle
    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      branchId.value = e.id;

      // Seçilen branşın alt kategorilerini getir
      if (e.id) {
        const result = await store.dispatch("getDatas", {
          api: "categories/getsubcategories",
          params: { pid: e.id }
        });
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
          subCategoryId.value = null; // Seçimi kullanıcıya bırak
        } else {
          subCategoryList.value = { data: [] };
          subCategoryId.value = null;
        }
      } else {
        subCategoryList.value = { data: [] };
        subCategoryId.value = null;
      }
    };

    // Kitap türü değiştiğinde kitap listesini güncelle
    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;

      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
          // Varsayılan olarak ilk kitabı seçili yap (çoklu seçimde dizi olarak)
          const firstId = dataArray[0].id || null;
          noteIds.value = firstId !== null ? [firstId] : [];
        } else {
          noteList.value = { data: [] };
          noteIds.value = [];
        }
      } else {
        noteList.value = { data: [] };
        noteIds.value = [];
      }
    };

    watch(
      () => choisesTxt.value,
      () => {
        let arr = choisesTxt.value.split(/A\)\s|B\)\s|C\)\s|D\)\s|E\)\s/g);
        arr.shift();
        newData.value.choiceList = arr;
      }
    );
    // Eski otomatik kategori watcher'ı kaldırdık; artık filtreler FilterBar üzerinden "Filtre" butonuyla uygulanıyor.
    onBeforeMount(async () => {
      await store.dispatch("getWorkFolder");

      // Yıl-Ay kombinasyonlarını yükle ve varsayılan seçimleri ayarla
      await loadYearMonths();
      if (yearMonthList.value.length > 0) {
        const first = yearMonthList.value[0];
        selectedYearMonth.value = first;
        const parts = first.split("-");
        if (parts.length === 2) {
          const [year, month] = parts;
          workYear.value = year;
          workMonth.value = month;
        }
      } else {
        // Fallback: eski Ay/Yıl listelerini kullan
        await loadMonths();
        await loadYears();
        await ensureWorkFolder();
      }

      catList.value = await getCatList();
      monthList.value = await getMonths();
      monthList.value.data.shift();
      monthList.value.data.forEach((itm, i) => {
        itm.id = i + 1;
      });

      // Ortak filtreler için başlangıç verilerini yükle (kitap türü + branş)
      const noteCats = await getNoteCatsList();
      notesCatsList.value = noteCats || { data: [] };

      const branchResult = await getCatList();
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        const filteredData = branchResult.data.filter(item => {
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          // initial questPart: 1 (Temel)
          return parentId === 1;
        });
        branchList.value = { data: filteredData };
        // Sayfa ilk açıldığında Branş için "Lütfen Seçiniz" gözüksün
        branchId.value = null;
      }

      loaded.value = true;
    });
    return {
      headdata,
      opts,
      listData,
      saveNew,
      newPanel,
      openSubList,
      newData,
      loaded,
      isLoading,
      months,
      years,
      workMonth,
      workYear,
      q,
      qs,
      searchfilter,
      dynamicPropertyFilters,
      filterBarRef,
      catList,
      catid,
      subcatid,
      subCatList,
      subNewCatList,
      openNewSubList,
      choisesTxt,
      minToolbar,
      monthList,
      canSave,
      store,
      imageAddedEditor,
      imagePastedEditor,
      newSubCatChange,
      filteredData,
      // FilterBar ile ilgili return'ler
      questPart,
      questParts,
      questPartOptions,
      yearMonthList,
      selectedYearMonth,
      yearMonthOptions,
      branchId,
      branchList,
      branchOptions,
      subCategoryId,
      subCategoryList,
      subCategoryOptions,
      notesCatsList,
      noteCategoryId,
      noteList,
      noteIds,
      noteCategoryOptions,
      noteOptions,
      onDynamicPropertyChange,
      clearDynamicFilters,
      reloadListWithFilters,
      onYearMonthChange,
      onQuestPartChange,
      onBranchChange,
      onNoteCategoryChange
    };
  }
};
</script>
